module.exports = __webpack_public_path__ + "img/antyk_i_opal.028bd1c8.jpg";